import { render } from "./ResellerCreditDetail.vue?vue&type=template&id=f8c21e4e&ts=true"
import script from "./ResellerCreditDetail.vue?vue&type=script&lang=ts"
export * from "./ResellerCreditDetail.vue?vue&type=script&lang=ts"

import "./ResellerCreditDetail.vue?vue&type=style&index=0&id=f8c21e4e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__